
// https://reactjs.org/docs/hooks-faq.html#is-it-safe-to-omit-functions-from-the-list-of-dependencies
// https://stackoverflow.com/questions/58624200/react-hook-useeffect-has-a-missing-dependency-dispatch
import React from 'react';
import { useDispatch } from 'react-redux';
import Flags from 'country-flag-icons/react/3x2'
import REDUX_UserConfig from '../../../objects/UserConfig/reducer'
import { errorCatch, GET, POST, useAuth, useLanguageContext } from 'fennec-ui';
import { JumboTabs } from 'antd-mobile';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';

function LangSwitchMobile({ userConfig, onChange }) {
    const auth = useAuth();
    const dispatch = useDispatch();
    const [language, setLanguage] = useLanguageContext();

    const { i18n } = useTranslation()

    const onChangeLang = (value) => {
        GET(auth, `/papi/language/${value}`, () => {
            setLanguage({lang: value})
        }, errorCatch)
        // POST(auth, "/api/setuserconfig", {
        //     key: "lang",
        //     value: value
        // }, ({ data }) => {
        //     var arr = [data];
        //     var obj = Object.fromEntries(arr.map(i => {
        //         return [
        //             i.key,
        //             i.value
        //         ]
        //     }));
        //     let o = REDUX_UserConfig.actions.setObject({ ...userConfig, ...obj });
        //     dispatch(o);
        //     if (onChange) {
        //         onChange(obj);
        //     }
        // }, errorCatch);
    };

    useEffect(() => {
        i18n.changeLanguage(language?.lang || "ru")
    }, [language])

    return (
        <div style={{ padding: "0px 0px" }}>
            <div>
                <JumboTabs activeKey={(language) ? language.lang : "ru"} onChange={(key) => onChangeLang(key)}>
                    <JumboTabs.Tab title={<Flags.RU title="Русский" style={{ width: "20px" }} />} description='Русский' key='ru' />
                    <JumboTabs.Tab title={<Flags.US title="English" style={{ width: "20px" }} />} description='English' key='en' />
                    <JumboTabs.Tab title={<Flags.ES title="Español" style={{ width: "20px" }} />} description='Español' key='es' />
                    <JumboTabs.Tab title={<Flags.TR title="Türkçe" style={{ width: "20px" }} />} description='Türkçe' key='tr' />
                </JumboTabs>
            </div>

            {/* <Dropdown overlay={<Menu selectable={true} selectedKeys={(userConfig && userConfig.lang) ? [userConfig.lang] : []}>
                <Menu.Item key="ru" onClick={() => onChangeLang("ru")}>
                    <div><Flags.RU title="Русский" style={{ width: "20px" }} /> RU</div>
                </Menu.Item>
                <Menu.Item key="en" onClick={() => onChangeLang("en")}>
                    <div><Flags.US title="English" style={{ width: "20px" }} /> EN</div>
                </Menu.Item>
                <Menu.Item key="es" onClick={() => onChangeLang("es")}>
                    <div><Flags.ES title="Español" style={{ width: "20px" }} /> ES</div>
                </Menu.Item>
            </Menu>}>
                <a className="ant-dropdown-link" onClick={e => e.preventDefault()}>
                    {(userConfig && userConfig.lang) && <div>
                        {userConfig.lang === 'ru' && <div>
                            <span><Flags.RU title="Русский" style={{ width: "20px" }} /> </span>
                            <span>{userConfig.lang.toUpperCase()}</span>
                        </div>}
                        {userConfig.lang === 'en' && <div>
                            <span><Flags.US title="English" style={{ width: "20px" }} /> </span>
                            <span>{userConfig.lang.toUpperCase()}</span>
                        </div>}
                        {userConfig.lang === 'es' && <div>
                            <span><Flags.ES title="Español" style={{ width: "20px" }} /> </span>
                            <span>{userConfig.lang.toUpperCase()}</span>
                        </div>}
                    </div>}
                    {(!userConfig || (userConfig && !userConfig.lang)) && <div>
                        <span><Flags.RU title="Русский" style={{ width: "20px" }} /> </span>
                        <span>RU</span>
                    </div>}
                </a>
            </Dropdown> */}
        </div>
    );
};

export default LangSwitchMobile;
// LangSwitchMobile.whyDidYouRender = true